import React from "react";
import type { TicketPriority } from "../../types/supportTicket";

interface Props {
  priority: TicketPriority;
}

const TicketPriorityBadge: React.FC<Props> = ({ priority }) => {
  return (
    <span className={`ticket-priority-badge ${priority.toLowerCase()}`}>
      {priority}
    </span>
  );
};

export default TicketPriorityBadge;
